import { useQuery, gql } from '@apollo/client';
import { Account } from '../types/Account';

export const GET_USER_ACCOUNTS_EXTERNAL_BANK_ACCOUNTS = gql`
  query GetUserAccounts($userId: Float!) {
    user(id: $userId) {
      accounts {
        id
        name
        accountNumber
        serviceCategoryName
        statementDate
        latestStatement {
          id
          amountDue
          statementBalance
          dueDate
          statementDate
          displayStatus
          approvalStatus
          isPaid
          isSkipped
          minimumAmount
          paymentTargetDate
          createdAt
          documentId
          hasAttachment
        }
      }
      externalBankAccounts {
        id
        accountNumber
        accountNickName
      }
    }
  }
`;

// Using Account interface from types/Account.ts

export interface ExternalBankAccount {
  id: string;
  accountNumber: string;
  accountNickName: string;
}

export interface UserAccountsData {
  user: {
    accounts: Account[];
    externalBankAccounts: ExternalBankAccount[];
  };
}

export interface UserAccountsVars {
  userId: number;
}

export default function useUserAccountsExternalBankAccounts({ userId }: UserAccountsVars) {
  return useQuery<UserAccountsData, UserAccountsVars>(
    GET_USER_ACCOUNTS_EXTERNAL_BANK_ACCOUNTS,
    {
      variables: { userId },
    }
  );
}
